/*
 * @Descripttion: 
 * @version: 
 * @Author: szj
 * @Date: 2023-05-08 11:57:52
 * @LastEditors: szj
 * @LastEditTime: 2023-05-11 16:55:14
 */
import { ControlSource } from './device'
import { LostControlActionInCommandFLight, WaylineLostControlActionInCommandFlight } from '/@/api/drone-control/drone'

export enum ControlSourceChangeType {
  Flight = 1,
  Payload = 2,
}

// 控制权变化消息
export interface ControlSourceChangeInfo {
  sn: string,
  type: ControlSourceChangeType,
  control_source: ControlSource
}

// 飞向目标点结果
export interface FlyToPointMessage {
  sn: string,
  result: number,
  message: string,
}

// 一键起飞结果
export interface TakeoffToPointMessage {
  sn: string,
  result: number,
  message: string,
}

// 设备端退出drc模式
export interface DrcModeExitNotifyMessage {
  sn: string,
  result: number,
  message: string,
}

// 飞行控制模式状态
export interface DrcStatusNotifyMessage {
  sn: string,
  result: number,
  message: string,
}

export const WaylineLostControlActionInCommandFlightOptions = [
  { label: '继续执行航线任务', value: WaylineLostControlActionInCommandFlight.CONTINUE },
  { label: '退出航线任务，执行失控动作', value: WaylineLostControlActionInCommandFlight.EXEC_LOST_ACTION }
]

export const LostControlActionInCommandFLightOptions = [
  { label: '返航', value: LostControlActionInCommandFLight.RETURN_HOME },
  { label: '悬停', value: LostControlActionInCommandFLight.HOVER },
  { label: '着陆', value: LostControlActionInCommandFLight.Land }
]

// 云台重置模式
export enum GimbalResetMode {
  Recenter = 0,
  Down = 1,
  RecenterGimbalPan = 2,
  PitchDown = 3,
}

export const GimbalResetModeOptions = [
  { label: '云台回中', value: GimbalResetMode.Recenter },
  { label: '云台向下', value: GimbalResetMode.Down },
  { label: '偏航回中', value: GimbalResetMode.RecenterGimbalPan },
  { label: '俯仰向下', value: GimbalResetMode.PitchDown }
]
